<div #tooltipElement class="tooltip flex justify-center">
  <ng-content></ng-content>
  <div *ngIf="visible" class="tooltip-text">
    {{ tooltip }}
  </div>
</div>
